import React from 'react'
import { Avatar } from '@mui/material'
import AccountStatusModal from '@/components/AccountStatusModal'
import {
  ConsumerUser,
  PaginatedResults,
} from '@/services/types/APIResponseType'
import { SupervisorInfo } from '@/services/index'
import { formatPhoneNumber, stringAvatar } from '@/utils'
import DummyImage from '@/assets/dummy-profile-image.svg'

interface ProfileDetailsPropsType {
  handleProfile: () => void
  consumersDetails: ConsumerUser
  handleFilterOpen: () => void
  checkInData: PaginatedResults[]
  handleUserStatusChange: (isBlocked: boolean) => void
  handleDateOpen: () => void
  supervisor: SupervisorInfo | null | undefined
  isSupervisorLoading: boolean
  onChangeSupervisor: () => void
}

const ConsumerProfileDetails: React.FC<ProfileDetailsPropsType> = ({
  handleProfile,
  consumersDetails,
  handleFilterOpen,
  handleUserStatusChange,
  handleDateOpen,
  supervisor,
  isSupervisorLoading,
  onChangeSupervisor,
}) => {
  return (
    <div className="table-container reg-consumer-table consumer-details before:rounded-[25px] !p-4 bg-[#FFFFFF1A]">
      <div className="reg-consumer-table1">
        <div className="reg-consumer-profile-content-wrapper">
          <div onClick={handleProfile} className="h-[66px] w-[66px] z-10">
            {consumersDetails?.profileDetails?.profilePic ? (
              <img
                alt="Profile"
                src={consumersDetails?.profileDetails.profilePic}
                className="consumer-avatar z-[98] !h-[66px] !w-[66px] border-4 border-solid border-white object-cover cursor-pointer"
              />
            ) : (
              <Avatar
                className="!bg-[#365F91] border-4 border-solid border-white !h-[66px] !w-[66px]"
                {...stringAvatar(
                  `${consumersDetails?.profileDetails.firstName} ${consumersDetails?.profileDetails.lastName}`,
                )}
              />
            )}
          </div>
          <div className="reg-consumer-profile-sub-content-wrapper">
            <div className="consumer-name">
              <label className="reg-consumer-profile-name">
                {consumersDetails?.profileDetails?.firstName}{' '}
                {consumersDetails?.profileDetails?.lastName}
              </label>
              <div className="!z-[99]">
                <AccountStatusModal
                  isActive={
                    !consumersDetails?.profileDetails.userId.isAccountBlocked
                  }
                  handleApiCall={handleUserStatusChange}
                />
              </div>
            </div>
            <div className="reg-consumer-profile-content-wrapper">
              <img src="/icon/call icon.png" alt="" />
              <label>
                {formatPhoneNumber(
                  consumersDetails?.profileDetails.phone,
                  consumersDetails?.profileDetails?.countryCode,
                )}
              </label>
              <img src="/icon/message icon.png" alt="" />
              <label>{consumersDetails?.profileDetails?.userId.email}</label>
            </div>
          </div>
        </div>
        <div className="reg-consumer-profile-content-wrapper2">
          <img src="/icon/download icon.png" alt="" onClick={handleDateOpen} />
          <img src="/icon/Filter 1.png" alt="" onClick={handleFilterOpen} />
        </div>
      </div>

      {/* Supervisor row */}
      <div className="mt-4 flex items-center justify-between gap-4 border-t border-white/10 pt-4">
        <div className="flex items-center gap-3">
          <p className="text-[#959595] text-sm font-medium whitespace-nowrap">
            Supervisor:
          </p>
          {isSupervisorLoading ? (
            <p className="text-white/50 text-sm">Loading…</p>
          ) : supervisor ? (
            <div className="flex items-center gap-2">
              <img
                src={supervisor.profilePic || DummyImage}
                alt={supervisor.firstName}
                className="w-8 h-8 rounded-full object-cover border border-white/20 flex-shrink-0"
              />
              <p className="text-white text-sm font-medium">
                {supervisor.firstName} {supervisor.lastName}
              </p>
            </div>
          ) : (
            <p className="text-white/50 text-sm italic">Not assigned</p>
          )}
        </div>
        <button
          onClick={(e) => {
            e.stopPropagation()
            console.log(
              '[ChangeSupervisor] button clicked, calling onChangeSupervisor:',
              onChangeSupervisor,
            )
            onChangeSupervisor()
          }}
          className="text-sm px-4 py-1.5 rounded-full border border-[#FB5012] text-[#FB5012] hover:bg-[#FB5012] hover:text-white transition-colors whitespace-nowrap"
        >
          Change
        </button>
      </div>

      <div className="consumer-check-in">
        Total Check-ins - {consumersDetails?.consumerCheckInCount}
      </div>
    </div>
  )
}

export default ConsumerProfileDetails
